import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import QRCode from "qrcode";


const PreviewJimSpencer = ({ show, onHide, content, count = 1, scale }) => {


  // console.log('content ', content)

  const [qrCode, setQrCode] = useState("");

  // ============================================================
  // GENERATE QR CODE
  // ============================================================
  useEffect(() => {
    const generateQR = async () => {
      try {
        // ========================================================
        // QR CODE NOW LINKS TO LERROS CONTACT PAGE
        // Scanning this QR code will open the Lerros HQ contact page
        // ========================================================
        const qrData = "https://company.lerros.com/de/kontakt/zentrale";

        const qr = await QRCode.toDataURL(qrData, {
          width: 150,
          margin: 0,
          errorCorrectionLevel: "M",
        });

        setQrCode(qr);
      } catch (error) {
        console.error("QR Code generation error:", error);
        setQrCode("");
      }
    };

    generateQR();
  }, []);




  const sinf = content?.SINF || "";

  // const { header, TotalQtys } = content;

  const header = [...(content?.header || [])];
  const TotalQtys = [...(content?.TotalQtys || [])];

  const qty = TotalQtys[TotalQtys.length - 1];

  header.pop();
  TotalQtys.pop();

  const SupplierArtNo = content?.STY.slice(0, -1) || "";
  // Combine headers and quantities, excluding zeros
  const combinedData = [];

  // Create combinations of headers and quantities
  for (let i = 0; i < Math.min(header.length, TotalQtys.length); i++) {
    const qty = Number(TotalQtys[i]); // Convert quantity to number
    if (qty !== 0) {
      combinedData.push({
        header: header[i],
        quantity: qty,
      });
    }
  }

  // this.length = combinedData.length;
  // console.log(this.length);
  // Split into two arrays of length 6 for valid entries only
  const headers1 = combinedData.slice(0, 6).map((item) => item.header);
  const quantities1 = combinedData.slice(0, 6).map((item) => item.quantity);
  const headers2 = combinedData.slice(6, 12).map((item) => item.header);
  const quantities2 = combinedData.slice(6, 12).map((item) => item.quantity);

  // Generate table headers
  const tableHeader1 = headers1
    .map((dt) => `<td class="size_col">${dt}</td>`)
    .join("");
  const tableHeader2 = headers2
    .map((dt) => `<td class="size_col">${dt}</td>`)
    .join("");
  const tableData1 = quantities1
    .map((dt) => `<td class="size_col">${dt} </td>`)
    .join("");
  const tableData2 = quantities2
    .map((dt) => `<td class="size_col">${dt} </td>`)
    .join("");

  const createValidSizeListString = (data) => {
    if (!data?.TotalQtys || !data?.header)
      return { valid_sizelist: "", valid_sizevalues: "" };

    const sizArr = data.TotalQtys;
    const new_size_list = [];
    const default_size_list = [];

    for (let i = 0; i < 12; i++) {
      if (sizArr[i] !== 0) {
        new_size_list.push(sizArr[i]);
        default_size_list.push(data.header[i]);
      }
    }

    const valid_sizelist = default_size_list.join(" + ");
    const valid_sizevalues = new_size_list.join(" + ") + " = " + sizArr[12];
    return { valid_sizelist, valid_sizevalues };
  };

  const carton_size = `${content?.length} X ${content?.width} X ${content?.height}`;
  // const carton_size = `12 X 12 X 12`;

  // Generate values
  const { valid_sizelist, valid_sizevalues } =
    createValidSizeListString(content);

  const tbl = `
    <div class= qr-main-div> 
    <div class="main-container-1">
      <div class="page-carton-no"><h1>${content?.SNO || ""} (A)</h1></div>
      <div class="container1">
        <div class="container1_line1">
          <div class="line1_left_data"><h2>AWG Article No</h2></div>
          <div class="line1_middle_data"><h2>:</h2></div>
          <div class="line1_right_data"><h2>${content?.ArtNo || ""}</h2></div>
        </div>
        <div class="container1_line1">
          <div class="line1_left_data"><h2>Color Name</h2></div>
          <div class="line1_middle_data"><h2>:</h2></div>
          <div class="line1_right_data"><h2>
          ${content?.CLRS[0] || ''}${content?.clrCode.trim() ? ` ( ${content?.clrCode} )` : ''}
      </h2></div>
        </div>

        ${content?.DIM.length > 0 ? ` <div class="container1_line1">
          <div class="line1_left_data"><h2>Dim</h2></div>
          <div class="line1_middle_data"><h2>:</h2></div>
          <div class="line1_right_data"><h2>${content?.DIM || ""}</h2></div>
        </div>`: ''}

        <div class="container1_line1">
          <div class="line1_left_data"><h2>AWG Order No.</h2></div>
          <div class="line1_middle_data"><h2>:</h2></div>
          <div class="line1_right_data"><h2>${content?.orderNo || ""}</h2></div>
        </div>
        <div class="container1_line1">
          <div class="line1_left_data"><h2>Supplier art No.</h2></div>
          <div class="line1_middle_data"><h2>:</h2></div>
          <div class="line1_right_data"><h2>${SupplierArtNo || ""}</h2></div>
        </div>

        <div class="container1_line5">
           <table>
            <thead>
              <tr>
                ${tableHeader1}
              </tr>
            </thead>
            <tr>${tableData1} </tr>
          
            <thead>
              <tr >
                ${tableHeader2}
              </tr>
            </thead>
            <tr>${tableData2} </tr>
          </table>
        </div>

        <div class="container1_line1">
          <div class="line1_left_data"><h2>Carton Weight</h2></div>
          <div class="line1_middle_data"><h2>:</h2></div>
          <div class="line1_right_data"><h2>${content?.GrossWt || ""} KGS</h2></div>
        </div>
        <div class="container1_line1">
          <div class="line1_left_data"><h2>Content</h2></div>
          <div class="line1_middle_data"><h2>:</h2></div>
          <div class="line1_right_data"><h2>${content ? qty : ' '} Pieces</h2></div>
        </div>
      </div>

      <div class="barcode-cell-outside">
        // ${content?.svg}
      </div>
    </div>

              <div class="qr-main">
              <div class="carton-id">${content?.carton_ID || ""}</div>
                  <img
                    src="${qrCode}"
                    class="qr-code1"
                    alt="QR Code"
                  />
               </div>
          </div>
    </div>
    
    <div class= qr-main-div> 
    <div class="main-container-1">
      <div class="page-carton-no"><h1>${content?.SNO || ""} (B)</h1></div>
      <div class="container2">
        <div class="main2">
          <div class="main2_line1">
            <div class="line1_left_data"><h2>AWG Article No.</h2></div>
            <div class="line1_middle_data"><h2>${" "}:</h2></div>
            <div class="line1_right_data"><h2>${content?.ArtNo || ""}</h2></div>
            <div class="main2_lin1_data"></div>
          </div>
          <div class="main2_line1">
            <div class="line1_left_data"><h2>AWG Order No.</h2></div>
            <div class="line1_middle_data"><h2>:</h2></div>
            <div class="line1_right_data"><h2>${content?.orderNo || ""}</h2></div>
          </div>

        </div>
      </div>
      <div class="barcode-cell-outside">
        // ${content?.svg}
      </div>
    </div>
              <div class="qr-main">
              <div class="carton-id">${content?.carton_ID || ""}</div>
                  <img
                    src="${qrCode}"
                    class="qr-code"
                    alt="QR Code"
                  />
               </div>
    </div>

    <div class= qr-main-div> 
    <div class="main-container-1">
      <div class="page-carton-no"><h1>${content?.SNO || ""} (C)</h1></div>
      <div class="container1">
        <div class="container1_line1">
          <div class="line1_left_data"><h2>STYLE NO.</h2></div>
          <div class="line1_middle_data"><h2>:</h2></div>
          <div class="line1_right_data"><h2>${content?.STY || ""}</h2></div>
        </div>
        <div class="container1_line1">
          <div class="line1_left_data"><h2>COL NO.</h2></div>
          <div class="line1_middle_data"><h2>:</h2></div>
          <div class="line1_right_data"><h2>
          ${content?.CLRS[0] || ''}${content?.clrCode.trim() ? ` ( ${content?.clrCode} )` : ''}

        </h2></div>
        
        </div>

           ${content?.DIM.length > 0 ? ` <div class="container1_line1">
          <div class="line1_left_data"><h2>DIM</h2></div>
          <div class="line1_middle_data"><h2>:</h2></div>
          <div class="line1_right_data"><h2>${content?.DIM || ""}</h2></div>
        </div>`: ''}

        <div class="container1_line1">
          <div class="line1_left_data"><h2>P.O. NO.</h2></div>
          <div class="line1_middle_data"><h2>:</h2></div>
          <div class="line1_right_data"><h2>${content?.PO || ""}</h2></div>
        </div>
        <div class="container1_line1">
          <div class="line1_left_data"><h2>LOT NO.</h2></div>
          <div class="line1_middle_data"><h2>:</h2></div>
          <div class="line1_right_data"><h2>${content?.LOTS[0] || ""}</h2></div>
        </div>
        <div class="container1_line1">
          <div class="line1_left_data"><h2>CARTON NO.</h2></div>
          <div class="line1_middle_data"><h2>:</h2></div>
          <div class="line1_right_data"><h2>${content?.SNO || ""}</h2></div>
        </div>

        <div class="container1_line5">
            <table>
            <thead>
              <tr>
                ${tableHeader1}
              </tr>
            </thead>
            <tr>${tableData1} </tr>
          
            <thead>
              <tr>
                ${tableHeader2}
              </tr>
            </thead>
            <tr>${tableData2} </tr>
          </table>
        </div>

        <div class="container1_line1">
          <div class="line1_left_data"><h2>QUANTITY</h2></div>
          <div class="line1_middle_data"><h2>:</h2></div>
          <div class="line1_right_data"><h2>${content ? qty : ''} PCS</h2></div>
        </div>
        <div class="container1_line1">
          <div class="line1_left_data"><h2>NUMBER OF LOTS</h2></div>
          <div class="line1_middle_data"><h2>:</h2></div>
          <div class="line1_right_data"><h2>${content?.NoOfLots || ""}</h2></div>
        </div>

        <div class="container1_line1">
          <div class="line1_left_data"><h2>CUSTOMER</h2></div>
          <div class="line1_middle_data"><h2>:</h2></div>
          <div class="line1_right_data"><h2>${content?.FCUS || ""}</h2></div>
        </div>
      </div>
      <div class="barcode-cell-outside">
       ${content?.svg}
      </div>
      </div>
              <div class="qr-main">
              <div class="carton-id">${content?.carton_ID || ""}</div>
                  <img
                    src="${qrCode}"
                    class="qr-code2"
                    alt="QR Code"
                  />
               </div>
    </div>

    <div class= qr-main-div> 
    <div class="main-container-1">
      <div class="page-carton-no"><h1>${content?.SNO || ""}(D)</h1></div>
      <div class="container-2">
        <div class="main2_">
          <div class="main2_left">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
              <path d="M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160l56 0 0 192-56 0c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4l-56 0 0-192 56 0c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"/>
            </svg>
          </div>
          <div class="main2_middle"><h1>STACK</h1><span><h1>STAPELN</h1></span></div>
          <div class="main2_left">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
              <path d="M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160l56 0 0 192-56 0c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4l-56 0 0-192 56 0c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="barcode-cell-outside">
        // ${content?.svg}
      </div>
    </div>
    <div class="qr-main">
                <div class="carton-id">${content?.carton_ID || ""}</div>
                  <img
                    src="${qrCode}"
                    class="qr-code"
                    alt="QR Code"
                  />
               </div>
    </div>`

  const htmlContent = `<html lang="en">
    <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Complex Table with Flexbox</title>
    <style>
    .main {
      // border: 2px solid red;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;

    }
    .tables-container{
      // border:2px solid green;
      
    }
    .qr-main-div{
      display: flex;
      justify-content: space-between;
      align-items: end;
      position: relative;   /* was: postion */
    }

    .main-container-1 {
      display: flex;
      flex-direction: column;
      page-break-after: always;
    }
    .page-carton-no{
      display: flex;
      justify-content: center;
      align-items: center;
      width:600px;
    }

    .container1 {
      border: 2px solid black;
      width: 615px;
      // height: 45vh;
      padding: 2% 1%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      /* page-break-after: always;  */
    }
    .container1_line1 {
      /* border: 2px solid black; */
      display: flex;
      width: 100%;
      height: 20%;
      /* displ; */
      /* height: 40%; */
      padding: -100px;
      /* padding: 1% 0%; */
      // margin: -10px;
    }
    .line1_left_data {
      width: 40%;
      /* border: 2px solid green; */
      font-size: 15px;
      /* font-weight: 400; */
    }
    .line1_middle_data {
      width: 5%;
      /* border: 2px solid blue; */
      font-size: 15px;
      font-weight: bold;
      text-align: center;
    }
    .line1_right_data {
      width: 40%;
      /* border: 2px solid red; */
      font-size: 15px;
      /* font-weight: bold; */
    }
    .container1_line5 {
      /* border: 2px solid red; */
      padding: 2% 0%;
      width: 100%;
    }
    .container1_line5 table{
      width:100%
    }
    .line5_size {
      border: 2px solid black;
      width: 19%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      font-weight: bold;
    }
    .line5_data1 {
      /* border: 2px solid blue; */
      height: 4vh;
      display: flex;
    }
    .container2 {
      border: 2px solid black;
      height: 45vh;
      width: 103%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 1% 1%;
      /* page-break-after: always; */
    }
    .container-2 {
      border: 2px solid black;
      height: 45vh;
      width: 103%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 1% 1%;
      /* page-break-after: always; */
    }
    .main2 {
      /* border: 2px solid red; */
      width: 100%;
    }
    .main2_line1 {
      /* border: 2px solid green; */
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      padding: 2% 0%;
    }
    .main2_ {
      /* border: 2px solid red; */
      width: 100%;
      height: 40vh;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5% 5%;
      font-family: Arial, Helvetica, sans-serif;
      font-weight: lighter;
    }
    .main2_left {
      /* border: 2px solid green; */
      width: 20%;
      height: 45vh;
      font-size: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .main2_middle {
      width: 60%;
      font-size: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    .common-cell {
      display: flex;
      flex-direction: column;
      text-align: center;
      height: 8vh;
    }
    .barcode-cell {
      /* border: 2px solid red; */
      padding: 2% 0% 3% 2%;
      min-width: 200px;
      min-height: 100px;
      /* padding-bottom: 11px; */
      /* width: 500px; */
      /* max-height: 200px; */
      /* border: 1px solid #000; */
      /* border-bottom: 2px solid #000; */
      /* border-top: none; */
      /* margin-bottom: 2%; */
    }
    .barcode-cell-outside {
      display: flex;
      max-width: 400px;
      max-height: 250px;
      margin: 90px 12px 0px 186px;
      /* top bottom right left; */
      display: none;
    }
    .cut_line_main {
      /* border: 2px solid black; */
      background: #f0f0f0;
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      height: 3vh;
      /* margin-top: 2%; */
      margin: 2% 0% 2% 0%;
    }
    #cut_logo {
      /* border: 2px solid black; */
      width: 2%;
      height: 3vh;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .cut_line {
      border-bottom: 1px dashed black;
      width: 98%;
      height: 0.1vh;
    }
     .qr-main {
      width: fit-content;        
      min-width: 96px;          
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;   
      flex-direction: column;
      padding-left:2em;
      }
    
      .qr-code {
         width: 96px;
        //  height: 114px;
         display: block;
         object-fit: contain;
      }
        
        .carton-id{
        padding: 0 4px 10px 0;
        font-weight: 500;
        font-size: 18px;
        white-space: nowrap; 
        width: fit-content;
        text-align: left;
        }

        .qr-code1 {
         width: 96px;
        //  height: 192px;
         display: block;
         object-fit: contain;
         object-position: bottom;
        }
         .qr-code2 {
         width: 96px;
        //  height: 325px;
         display: block;
         object-fit: contain;
         object-position: bottom;
        }
    
        .size_col{
            border : 2px solid black !important ;
            text-align : center ;
            width : 73px ;
            height : 35px;
            padding : 0px;
        }
  
  


    @media print {
      .main-container-1 {
        display: flex;
        flex-direction: column;
        page-break-after: always;
      }
      .container1 {
        height: 45vh;
        width: 70%;
        margin-right: 10px;
        margin-left: 100px;
        margin-top: 25px;
        padding: 10px 10px 10px 10px;
        /* page-break-after: always; */
      }
      .container2 {
        height: 45vh;
        width: 70%;
        margin-right: 10px;
        margin-left: 100px;
        margin-top: 25px;
        /* page-break-after: always;  */
      }
      .common-cell {
        height: 5vh;
      }
      .line5_data1 {
        height: 3vh;
      }
      .cut_line_main {
        width: 92%;
        margin-right: 2%;
        margin-top: 6%;
        margin-bottom: 6%;
      }
      .main2_ {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 85%;
      }
      .main2_left {
      font-size: 15px;
        visibility: visible !important;
        width: 80px;
        height: 200px;
      }
      .main2_middle {
        width: 50%;
        font-size: 18px;
      }
          table {
    border-collapse: collapse;
    font-size: 12px;
    padding: 0;
    margin: 0;
    font-size : 17px;
    // font-weight: bold; 
}
    }
  </style>

  </head>
      <body>
        <div class="tables-container">
              ${tbl}
        </div>
      </body>
  </html>`
  return (
    //   <Modal.Body
    //   style={{
    //     maxHeight: '70vh',
    //     overflow: 'auto',
    //     padding: '4px',
    //     // backgroundColor: '#f8f9fa',
    //     // border: '2px solid blue',
    //     boxShadow: '0 0 10px rgba(0,0,0,0.1)',
    //     display: 'flex',
    //     justifyContent: 'center',
    //     alignItems: 'center',
    //     width:'1000px'
    //   }}
    // >
    <div
      style={{
        // width: 'auto', 
        // height: 'auto',
        overflow: 'visible',
        zoom: scale,
        padding: "100px",
        boxSizing: 'border-box',
        // display: 'flex',
        // justifyContent: "flex-start",
        // alignItems: 'flex-start', 
      }}
      dangerouslySetInnerHTML={{
        __html: htmlContent
      }}
    />
    // </Modal.Body>
  );
};

export default PreviewJimSpencer;
